/* ============================================================
   TURNING HEADS — page JS
   Loaded only on page.turning-heads via section asset_url.
   Vanilla JS. No dependencies. Respects prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  if (window.__turningHeadsInit) return;
  window.__turningHeadsInit = true;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- INIT once DOM is ready ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initHero();
    initMeaningCollage();
    initMachine();
  }

  /* ============================================================
     1) HERO — scroll-based rotation on title + can
     ============================================================ */
  function initHero() {
    var hero = document.querySelector('[data-th-hero]');
    if (!hero || reducedMotion) return;

    var rotateTargets = hero.querySelectorAll('[data-th-rotate]');
    if (!rotateTargets.length) return;

    var ticking = false;
    function update() {
      var rect = hero.getBoundingClientRect();
      var h = hero.offsetHeight || window.innerHeight;
      /* progress: 0 at top of hero, increases as user scrolls past */
      var progress = Math.min(Math.max(-rect.top / h, 0), 1.2);
      /* Max rotation 22deg — between the requested 15–30 range */
      var deg = (progress * 22).toFixed(2);
      var offsetY = (progress * 60).toFixed(1);

      rotateTargets.forEach(function (el) {
        el.style.setProperty('--th-scroll-rotate', deg + 'deg');
        el.style.setProperty('--th-scroll-y', offsetY + 'px');
      });

      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ============================================================
     2) MEANING — culture card collage flash on hover
     ============================================================ */
  function initMeaningCollage() {
    var cultureCards = document.querySelectorAll('.th-card--culture');
    if (!cultureCards.length || reducedMotion) return;

    cultureCards.forEach(function (card) {
      var flash = card.querySelector('[data-th-flash]');
      if (!flash) return;

      var lastFlash = 0;
      function trigger() {
        var now = Date.now();
        if (now - lastFlash < 400) return; /* throttle */
        lastFlash = now;
        flash.classList.remove('is-flashing');
        /* force reflow so animation restarts */
        void flash.offsetWidth;
        flash.classList.add('is-flashing');
      }

      card.addEventListener('mouseenter', trigger);
      card.addEventListener('touchstart', trigger, { passive: true });
    });
  }

  /* ============================================================
     3) HEAD TURNER MACHINE — button states
     ============================================================ */
  function initMachine() {
    var machines = document.querySelectorAll('[data-th-machine]');
    if (!machines.length) return;

    machines.forEach(function (machine) {
      var buttons = machine.querySelectorAll('[data-th-btn]');
      var states = machine.querySelectorAll('[data-th-state]');
      if (!buttons.length || !states.length) return;

      function activate(key) {
        var found = false;

        states.forEach(function (state) {
          var match = state.getAttribute('data-th-state') === key;
          if (match) {
            state.classList.add('is-active');
            /* trigger entrance animation */
            state.classList.remove('is-entering');
            void state.offsetWidth;
            state.classList.add('is-entering');
            found = true;
          } else {
            state.classList.remove('is-active', 'is-entering');
          }
        });

        buttons.forEach(function (btn) {
          var match = btn.getAttribute('data-th-btn') === key;
          btn.classList.toggle('is-active', match);
          btn.setAttribute('aria-pressed', match ? 'true' : 'false');
        });

        return found;
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-th-btn');
          activate(key);
        });

        /* keyboard support — arrow keys cycle between buttons */
        btn.addEventListener('keydown', function (e) {
          var idx = Array.prototype.indexOf.call(buttons, btn);
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            next = buttons[(idx + 1) % buttons.length];
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            next = buttons[(idx - 1 + buttons.length) % buttons.length];
          }
          if (next) {
            e.preventDefault();
            next.focus();
            next.click();
          }
        });
      });
    });
  }
})();
